import React from 'react';

/**
 * Marca d'ARGOS: «el marc».
 *
 * Quatre cantonades que delimiten un espai i, al centre, el que s'hi examina.
 * Són marques de registre, de les que fan servir la impremta i el dibuix tècnic
 * per dir «l'àrea és aquesta». La primera feina de qualsevol anàlisi és acotar la
 * pregunta: què entra i què queda fora.
 *
 * Adoptada el 07/08/2026 en substitució de l'hexàgon amb diana, que tenia tres
 * problemes: el color (#0284c7) havia desaparegut de la paleta, l'hexàgon és el
 * lloc comú de la categoria, i els traços concèntrics es convertien en una taca
 * a 16 px.
 *
 * És monocroma i hereta el color del context via `currentColor`, com la resta
 * d'icones: la mateixa marca serveix per al mode clar i el fosc.
 *
 * A mides petites el traç s'engreixa una mica perquè no s'aprimi òpticament;
 * per això hi ha la variant `compacta`, que és la que fa servir el favicon.
 */
function Logo({ className = '', compacta = false, ...props }) {
  const gruix = compacta ? 2.6 : 2;
  const rombe = compacta
    ? 'M16 12.2L19.8 16L16 19.8L12.2 16Z'
    : 'M16 12.6L19.4 16L16 19.4L12.6 16Z';

  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      role="img"
      aria-label="ARGOS"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeWidth={gruix}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.5 11V4.5H11" />
        <path d="M21 4.5H27.5V11" />
        <path d="M27.5 21V27.5H21" />
        <path d="M11 27.5H4.5V21" />
      </g>
      <path d={rombe} fill="currentColor" />
    </svg>
  );
}

export default Logo;
